import type { RouteObject } from 'react-router';
import { CompanySettingsPage } from './pages/CompanySettingsPage';

export const COMPANY_SETTINGS_ROUTES: RouteObject[] = [{ path: 'company', element: <CompanySettingsPage /> }];
